module.exports = __webpack_public_path__ + "img/version-title.896e2046.svg";